import React from "react";
import {withRouter} from "react-router-dom";
import { TYPE, URL } from "../../constant";
import { useUserInfo } from "../../hooks";
import useAsideState from "../../hooks/useAsideState";

const HomeButton = withRouter((props) => {
  const { info } = useUserInfo();
  const { setAsideState } = useAsideState();

  const moveHome = () => {
    const tab = 'home';
    setAsideState({tab});

    localStorage.setItem('learning.id', '');
    props.history.push(URL.SELECT_LEARNING);
    console.log("***** 주제학습 페이지 -> 메인 페이지")
  };

  return (
    <>
      <button className="btn_exit hide_pc hide_m" type="button" onClick={moveHome}>
        {
          info.channelCode === TYPE.CHANNEL.GLOBAL01 
            ? (
              <img src={`${process.env.PUBLIC_URL}/static/images/icon/btn_back.svg`} alt="" />
            )
            : (
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/static/images/icon/ic_back@2x.png`}
              />
            )
        }
      </button>
    </>
  );
});

export default HomeButton;


